module.exports = __webpack_public_path__ + "img/find.6cfcdd64.svg";